import { createContext, useCallback, useContext, useEffect, useState } from 'react';

export const TOUR_KEY = 'speak23_tourCompleted';

export const TourContext = createContext(null);

export function useTour() {
  const restartRef = useContext(TourContext);
  if (!restartRef) throw new Error('useTour must be used inside <TourProvider>');

  const restart = useCallback(() => {
    localStorage.removeItem(TOUR_KEY);
    restartRef.current?.();
  }, [restartRef]);

  return { restart };
}

// Lets a page component know it's the one currently being spotlighted by the
// walkthrough tour (WalkthroughTour dispatches 'tour:step' with the active
// step's target selector whenever it changes). Pass the same selector string
// used as that step's `target` in buildSteps, e.g. '[data-tour="saeulen-cards"]'.
// Used to render a shortened/collapsed version of a section for the duration
// of that step, so target+tooltip together fit an xs viewport without the
// section itself needing to shrink or the user needing to scroll.
export function useIsTourStepActive(targetSelector) {
  const [activeTarget, setActiveTarget] = useState(null);
  useEffect(() => {
    const handler = (e) => setActiveTarget(e.detail?.target ?? null);
    window.addEventListener('tour:step', handler);
    return () => window.removeEventListener('tour:step', handler);
  }, []);
  return activeTarget === targetSelector;
}
